import { render, staticRenderFns } from "./DetalleSabados.vue?vue&type=template&id=3fbd706f&"
import script from "./DetalleSabados.vue?vue&type=script&lang=js&"
export * from "./DetalleSabados.vue?vue&type=script&lang=js&"
import style0 from "./DetalleSabados.vue?vue&type=style&index=0&id=3fbd706f&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports